import { render, staticRenderFns } from "./CIPage.vue?vue&type=template&id=c905f714&scoped=true&"
import script from "./CIPage.vue?vue&type=script&lang=js&"
export * from "./CIPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c905f714",
  null
  
)

export default component.exports